import sha256 from 'crypto-js/sha256'
import base64 from 'crypto-js/enc-base64'
import querystring from 'querystring'
import axios from "axios"
import moment from "moment"

export default {
    props : {
      /** URL to the authentication server */
      authorizeUrl: { type: String, default: "" },

      /** Where the tokens will be stored */
      tokenUrl: { type: String, default: "" },

      /** Where to redirect the user to after logging the user out */
      logoutUrl: { type: String, default: "" },

      /** Scope tells the server that this client uses oidc for authentication */
      scope: { type: String, default: "" },

      /** If the account is already logged in any tab, It automatically allows the application  */
      autologin: { type: Boolean, default: false },

      /** The name of the client in Keycloak setup for this service */
      client_id: { type: String, default: "" },

      /** Seperate secret key generated for seperate client  */
      client_secret: { type: String, default: "" },

      /** Where to redirect the user to after successful authentication */
      redirect_uri: { type: String, default: "" },

      /** Debugging the code */
      debug: { type: Boolean, default: true },

      /** User details are stored in this credentials */
      credentials: { type: Object, default: () => null },

      /** If a token gets expired automatically it gets refreshed and generate new token */
      refreshTokenPeriodMs: { type: Number, default: 90000 },//milliseconds

      /** Incrementing this fires off a login event */
      loginIncrementor: { type: Number, default: 0 },
    },
    created()
    {
        this.registerUrlChangeEventListener();
    },
    mounted()
    {
        if(!!this.credentials)
        {
            this.internalCredentials = this.credentials;
        }
        
    },
    data()
    {
        return {
            pause : false,
            currentUrl : null,
            internalCredentials : null,
            currentTime : null,
            currentTimeInterval : null,
        }
    },
    watch : {
        credentials(newVal)
        {
            this.internalCredentials = newVal;
        },
        internalCredentials(newVal)
        {
           /**
             * If any change occurs in user details this credentials will be updated  
            */
            this.$emit("update:credentials", newVal);
        },
        msUntilRefresh(newVal)
        {
            if(newVal <= 0)
            {
                this.refreshToken();
            }
        }
    },
    computed : {
        _moment()
        {
            return moment;
        },
        expiresOn()
        {
            return this.credentials ? this.credentials.expires_on : null;
        },
        msUntilExpiry()
        {
            if(this.pause)
            {
                debugger;
            }
            return moment(this.expiresOn).diff(moment(this.currentTime));
        },
        msUntilRefresh()
        {
            return this.msUntilExpiry - this.refreshTokenPeriodMs;
        },
        validTokenPerc()
        {
            if(!!this.credentials)
            {
                return Math.floor((this.msUntilRefresh / (this.credentials.expires_in * 1000)) * 100);
            }
            return 0;
        },
        styles()
        {
            var returnValue = {};
            if(this.debug){
                returnValue = {
                    "border" : "1px black solid",
                    "padding" : "15px",
                    "border-radius" : "10px",
                    "margin" : "10px",
                }
            }
            return returnValue;
        },
        allowContent()
        {
            return !!this.credentials && !!this.credentials.access_token;
        },
        querystring()
        {
            if(this.currentUrl)
            {
                if(this.$route)
                {
                    return this.$route.query;
                }
                if(window.document.location.search)
                {
                     return querystring.parse(window.document.location.search.substr(1));
                }
            }
            return {};
        },
        loginUrl() {
            var result = [this.authorizeUrl,
                `?response_type=code`,
                `&client_id=${this.client_id}`,
                `&scope=${this.scope} offline_access`,
                `&redirect_uri=${encodeURIComponent(this.redirect_uri)}`,
                `&state=${this.state}`,
                `&code_challenge_method=S256`,
                `&response_mode=query`,
                `&code_challenge=${this.simpleUrlEncode(this.code_challenge)}`,
            ]
            if (!!this.resource) {
                result.push(`&resource=${this.resource}`);
            }

            return result.join("");
        },
        state() {
            return this.generateRandomKey();
        },
        code_verifier() {
            return this.generateRandomKey(43);
        },
        code_challenge() {
            const hash = sha256(this.code_verifier);
            const encoded = base64.stringify(hash);
            const trimmed = encoded.substring(0, encoded.length - 1); // Remove the = delimiter
            return trimmed;
        },

        hasOauthResponse() {
            var keys = Object.keys(this.querystring)
            if (keys.indexOf("code") >= 0 && keys.indexOf("session_state") >= 0 && keys.indexOf("state") >= 0)
            {
                return true;
            }
            return false;
        },
        refreshTokenOptions() {
            if (!this.credentials) { return {} };
            return {
                'client_id': this.client_id,
                'scope': this.scope,
                'refresh_token': this.credentials.refresh_token,
                'grant_type': 'refresh_token',
            };
        },
    },
    methods : {
        expireCredentials()
        {
            // this.pause = true;
            // var self = this;
            // setTimeout(() => self.pause = false, 5000);
            // // this.internalCredentials.expires_in = 5;//seconds
            // this.internalCredentials.expires_on = moment().format("YYYY-MM-DDTHH:MM:mmZ");
            var credCache = JSON.parse(localStorage.getItem("credential-cache"))

            var now = moment().subtract(10, "minutes").format()
            credCache[this.client_id].expires_on = now;
            credCache[this.client_id].$expires_on = now;
            credCache[this.client_id].expires_in = 60;
            credCache[this.client_id].ext_expires_in = 60;
            localStorage.setItem("credential-cache", JSON.stringify(credCache));
            location.reload();

        },
        startRefreshTimer()
        {
            this.currentTimeInterval  = setInterval(() => {
                this.currentTime = moment().toISOString();
            }, 1000);
        },
        extendCredentials(baseCredentials)
        {
            baseCredentials.time_stamp = moment().toISOString();
            baseCredentials.expires_on = moment().add(baseCredentials.expires_in, "seconds").toISOString();
            return baseCredentials;
        },
        async refreshToken() {
            let formData = new FormData();
            Object.keys(this.refreshTokenOptions).forEach(e => {
                formData.append(e, this.refreshTokenOptions[e]);
            });

            var response = await axios({
                method: 'post',
                url: this.tokenUrl,
                data: formData,
            });
            this.internalCredentials = this.extendCredentials(response.data);

        },
        registerUrlChangeEventListener()
        {
            this.currentUrl = window.document.location.href;
            var self = this;
            window.addEventListener('popstate', function(e){
                self.currentUrl = window.document.location.href;
            });
        },
        generateRandomKey(length = 32) {
            var result = [];
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
            }
            return result.join("");
        },
        simpleUrlEncode(str) {
            return str
                //.toString('base64')
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=/g, '');
        },
    }

}